import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import jwtDecode from 'jwt-decode';

import store from './store/store';
import App from './components/App';
import history from './history/browserHistory';
import { isAuthenticated, authenticate, token } from './auth/indentityAuth';
import { setUser } from './actions/userActions';
import * as serviceWorker from './serviceWorker';

if (isAuthenticated()) {
  store.dispatch(setUser({ name: jwtDecode(token.access_token)['nxt:entity:name'] }));
  history.push(token.state);

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  serviceWorker.unregister();
} else {
  authenticate();
}
